import HeaderBar from 'common/components/HeaderBar'
import withInjection from '@piconetworks/with-injection'

import { colors } from '@piconetworks/functions'
import Loader from 'common/modules/loader'
import xFrame from 'common/xFrame'

const mapStateToProps = (state, props) => {
    const linkColor = Loader.selectors.linkColor(state)
    const hideLogin = !!props?.router?.query?.hideLogin

    return {
        ...props,
        linkColor,
        contrastColor: colors.getContrastColor(linkColor),
        textColor: colors.getContrastColor(linkColor),
        memberType: Loader.selectors.memberType(state),
        isLoggedIn: !!Loader.selectors.hasUserLoader(state),
        userInitials: Loader.selectors.userInitials(state),
        userEmail: Loader.selectors.userEmail(state),
        hideLogin,
    }
}

const mapDispatchToProps = (dispatch) => ({
    onLoginButtonClick: () => {
        xFrame.header.goToPromptLogin({
            dispatch,
        })
    },
})

const InjectedHeaderBar = withInjection(HeaderBar, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedHeaderBar
